import { useRef, KeyboardEvent } from 'react';

interface MfaCodeInputProps {
  code: string[];
  setCode: React.Dispatch<React.SetStateAction<string[]>>;
  evaluateMFA: () => void;
}

export const MfaCodeInput = ({ code, setCode, evaluateMFA }: MfaCodeInputProps) => {

  const inputsRef = useRef<HTMLInputElement[]>([]);

  const handleMfaCode = (val: string, idx: number) => {
    if (!isNaN(Number(val))) {
      const auxCode = [...code];
      auxCode[idx] = val;
      setCode(auxCode);

      /*
        If the index of the input array you are currently on is
        less than 5 and the next input exists, automatically focus
        the next input once you write a number.
      */
      if (val && idx < 5 && inputsRef.current[idx + 1]) {
        inputsRef.current[idx + 1].focus();
      }
    }
  };

  const handleKeyDown = (e: KeyboardEvent<HTMLInputElement>, idx: number) => {
    if (e.key === 'Backspace' && !code[idx] && idx > 0) {
      inputsRef.current[idx - 1].focus();
    }

    if (e.key === 'Enter' && idx === code.length - 1) {
      evaluateMFA();
    }
  };

  const handleOnPaste = (e: React.ClipboardEvent<HTMLInputElement>) => {
    e.preventDefault();
    const pastedData = e.clipboardData.getData('text/plain').split('');
    if (pastedData.length === code.length) {
      setCode(pastedData);
      inputsRef.current[code.length - 1].focus();
    }
  };

  return (
    <div className="flex w-full justify-between gap-2">
      {code.map((digit, idx) => (
        <input
          key={idx}
          className="flex p-4 text-4xl w-14 h-14 border bg-gray-900 border-gray-600 focus:outline-none rounded-2xl focus:border-cyan-300"
          type="text"
          maxLength={1}
          value={digit}
          onChange={(e) => handleMfaCode(e.target.value, idx)}
          onKeyDown={(e) => handleKeyDown(e, idx)}
          ref={(el) => {
            if (el) {
              inputsRef.current[idx] = el;
            }
          }}
          autoFocus={idx === 0}
          onPaste={(e) => handleOnPaste(e)}
        />
      ))}
    </div>
  );
};
